import { useTranslation } from "react-i18next"

import CookiesTable from "../components/CookiesPolicy/CookiesTable"
import LegalPageContent from "../components/LegalPageContent/LegalPageContent"
import SEO from "../components/SEO/SEO"
import useSiteTitle from "../hooks/use-site-title"

const CookiesPolicy = () => {
  const { t } = useTranslation()

  const title = t("Cookies Policy")

  const siteTitle = useSiteTitle(false)

  return (
    <LegalPageContent>
      <SEO title={title} description={title} siteTitle={siteTitle} />
      <div>
        <h1>
          <span>{title}</span>
        </h1>
        {/* Prosa legal estática (contenido del repo, sin tablas). */}
        <div dangerouslySetInnerHTML={{ __html: t("cookiesIntro") }} />
        {/* Tabla de cookies renderizada en JSX desde datos (sin innerHTML). */}
        <h2>{t("cookiesUsedTitle")}</h2>
        <CookiesTable />
        <div dangerouslySetInnerHTML={{ __html: t("cookiesDetails") }} />
      </div>
    </LegalPageContent>
  )
}

export default CookiesPolicy
